import { themeBackgrounds } from "@dana/MobiusOverrides/styles/colors";
import { fontWeights } from "@dana/MobiusOverrides/styles/typography";
import { orderSummaryStyles } from "@dana/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationOrderSummary";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

orderSummaryStyles.container = mergeToNew(orderSummaryStyles.container, {
  css: css`
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid ${themeBackgrounds.lightGray};
  `
});

orderSummaryStyles.cartTotal = mergeToNew(orderSummaryStyles.cartTotal, {
    subtotalLabel: {
        weight: fontWeights.regular,
    },
    promotionLabel: {
        weight: fontWeights.regular,
    },
    discountsLabel: {
        weight: fontWeights.regular,
    },
    shippingAndHandlingLabel: {
        weight: fontWeights.regular,
    },
    otherChargesLabel: {
        weight: fontWeights.regular,
    },
    taxLabel: {
        weight: fontWeights.regular,
    },
    totalLabel: {
        weight: fontWeights.regular,
    },
    subtotalValue: {
        weight: fontWeights.semiBold,
    },
    promotionValue: {
        weight: fontWeights.semiBold,
    },
    discountsValue: {
        weight: fontWeights.semiBold,
    },
    shippingAndHandlingValue: {
        weight: fontWeights.semiBold,
    },
    otherChargesValue: {
        weight: fontWeights.semiBold,
    },
    taxValue: {
        weight: fontWeights.semiBold,
    },
    totalValue: {
        weight: fontWeights.semiBold,
    },
});